import moment from 'moment';

export default class Factura {
    constructor(factura) {
        if (factura) {
            this.fechaFact = factura.fechaFact || factura.fecha ? moment(factura.fecha).toDate() : '' || '';
            this.numeroDoc =  factura.numeroDoc || factura.numero_documento || '';
            this.documentoAfectado = factura.documentoAfectado || factura.documento_afectado || '';
            this.tipo = factura.tipo || '01';
            this.noControl =  factura.noControl || factura.numero_control || '';
           // this.totalCompra =  factura.totalCompra || '';
            this.sinCredito =  parseFloat(factura.sinCredito) || parseFloat(factura.sin_credito) || 0.00;
            this.baseImponible =  parseFloat(factura.baseImponible || 0) || parseFloat(factura.base_imponible || 0) || 0.00;
            this.percentage = factura.percentage || factura.porcentaje_retencion || 1;
            this.iva_offset = factura.iva_offset || 0;
            this.porcentaje_iva = factura.porcentaje_iva || 16;
            this.tipo_pago = factura.tipo_pago || 'efectivo';

            /*
            if (this.tipo_pago === 'electronico' && this.baseImponible > 1999999) {
                this.porcentaje_iva = 7;
            } else if (this.tipo_pago === 'electronico' && this.baseImponible < 2000000) {
                this.porcentaje_iva = 9;
            } else {
                this.porcentaje_iva = 12;
            }
            */
        }
    }

    get totalCompra() {
        return (parseFloat(this.baseImponible || 0)+parseFloat(this.sinCredito || 0)+parseFloat(this.iva || 0)).toFixed(2) || '';
    }
    get totalPagar() {
        return (this.totalCompra-this.retencion).toFixed(2);
    }
    
    get fecha() {
            if (!this.fechaFact) return '';
            let day = this.fechaFact.getUTCDate() < 10 ? '0' + this.fechaFact.getUTCDate() : this.fechaFact.getUTCDate(),
                month = (this.fechaFact.getUTCMonth() + 1) < 10 ? '0' + (this.fechaFact.getUTCMonth() + 1) : this.fechaFact.getUTCMonth() + 1,
                year = this.fechaFact.getUTCFullYear();
                
            return moment(this.fechaFact).format('DD-MM-YYYY');
    }

    get dateAPI() {
            if (!this.fechaFact) return '';
            let day = this.fechaFact.getUTCDate() < 10 ? '0' + this.fechaFact.getUTCDate() : this.fechaFact.getUTCDate(),
                month = (this.fechaFact.getUTCMonth() + 1) < 10 ? '0' + (this.fechaFact.getUTCMonth() + 1) : this.fechaFact.getUTCMonth() + 1,
                year = this.fechaFact.getUTCFullYear();
                
            return moment(this.fechaFact).format('YYYY-MM-DD');
    }
    
    get iva() {
        return ((parseFloat(this.baseImponible || 0)*(this.porcentaje_iva/100))+parseInt(this.iva_offset)/100).toFixed(2);
    }

    
    get retencion() {
        return this.roundToTwo(this.iva*this.percentage/100);
    }

    roundToTwo(num) {    
        return +(Math.round(num + "e+2")  + "e-2");
    }
}


/** WEBPACK FOOTER **
 ** ./app-react/Models/Factura.js
 **/